module.exports = __webpack_public_path__ + "img/user_icon.b9c2da71.png";